import React from "react";
import {
    Box,
    Typography,
    Grid,
    Container,
    useTheme,
} from "@mui/material";
import Footer from "./Footer";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

const ContactUs = () => {
    const theme = useTheme();

    return (
        <Box>
            <Box
                sx={{
                    pt: { xs: 10, md: 12 },
                    pb: { xs: 6, md: 8 },

                }}
            >
                <Container maxWidth="md">
                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            textAlign: "center",
                            lineHeight: 1.1,
                            mb: 3,
                            color: theme.palette.text.primary,
                            animation: "fadeUp 0.9s ease-out both",
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        Get in{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            touch
                        </Box>{" "}
                        with us
                    </Typography>

                    <Typography
                        variant="body1"

                        sx={{
                            textAlign: "center",
                            fontSize: { xs: "12px", sm: "14px", md: "16px" },
                            color: "#555",
                            maxWidth: 640,
                            mx: "auto",
                        }}
                    >
                        We’re here to help you. Whether you have questions, need
                        support, or want to collaborate — just reach out. Our
                        team is ready to assist you on your financial journey.
                    </Typography>
                </Container>
            </Box>

            <Box
                sx={{
                    // mt: 6,
                    pb: { xs: 2, md: 6 },
                    px: { xs: 2, md: 8 },
                    maxWidth: "1200px",
                    mx: "auto",
                    // background: "red"

                }}
            >
                <Grid container spacing={6} alignItems="center">
                    {/* MAP */}
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src="https://img.freepik.com/premium-vector/india-dotted-map-modern-halftone-style_141130-19154.jpg"
                            alt="India Map"
                            sx={{
                                width: "100%",
                                maxHeight: 480,
                                objectFit: "contain",
                                filter: "grayscale(25%)",
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                p: { xs: 4, md: 5 },
                                borderRadius: "18px",
                                width: "100%",
                                minHeight: "260px",
                                background: "#ffffff",
                                border: `2px solid #00a8a8`,
                                transition: "all 0.3s ease",
                                position: "relative",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                gap: 4,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",

                                "&:hover": {
                                    transform: "translateY(-6px)",
                                    borderLeftWidth: "4px",
                                    borderRightWidth: "4px",
                                    boxShadow: "0 15px 30px rgba(0,0,0,0.12)",
                                },

                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "0px",
                                    background: "#00a8a8",
                                    borderBottomLeftRadius: "16px",
                                    borderBottomRightRadius: "16px",
                                    transition: "height 0.3s ease",
                                },

                                "&:hover::after": {
                                    height: "12px",
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: 18,
                                    mb: 1.5,
                                    color: theme.palette.text.primary,
                                }}
                            >
                                Contact Details
                            </Typography>

                            {/* Location */}
                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "50%",
                                        background: theme.palette.primary.main,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 8px 18px rgba(0,168,168,0.25)",
                                    }}
                                >
                                    <LocationOnOutlinedIcon
                                        sx={{
                                            color: "#fff",
                                            fontSize: 20,
                                        }}
                                    />
                                </Box>

                                <Typography sx={{ fontSize: "16px", color: "#444" }}>
                                    Plot No C-9, Asha Officers Colony
                                    <br />
                                    RK Puram, Secunderabad, Hyderabad
                                </Typography>
                            </Box>

                            {/* Phone */}
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <CallOutlinedIcon
                                    sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 26,
                                    }}
                                />
                                <Typography sx={{ fontSize: "16px", color: "#444" }}>
                                    +91 95950 27710
                                </Typography>
                            </Box>

                            {/* Email */}
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <EmailOutlinedIcon
                                    sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 26,
                                    }}
                                />
                                <Typography sx={{ fontSize: "16px", color: "#444" }}>
                                    <a
                                        href="mailto:support@arthgyan.com"
                                        style={{
                                            color: "#444",
                                            textDecoration: "none",
                                        }}
                                    >
                                        support@arthgyan.com
                                    </a>
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Footer />
        </Box>
    );
};

export default ContactUs;
